import { cloneDeep } from 'lodash-es'
import createMicroApp, { createProdUrl } from '@/components/MicroApp/createMicroApp.tsx'
import MicroRoute from '@/layouts/MicroRoute.tsx'
import WorkOrderLayout from '@/layouts/WorkOrder'
import WorkOrderEmptyPage from '@/layouts/WorkOrder/EmptyPage.tsx'
import MainRoute from '@/layouts/MainRoute.tsx'
import TextMessageLink from '@/pages/textMessageLink'
import LoginSimplify from '@/pages/login-simplify'
import Login from '@/pages/login'
import App from '@/App.tsx'
import ErrorPage from '@/pages/error'
import Notfound from '@/pages/notfound'

/** Layout：菜单布局、空白布局、工单布局 **/
const layoutDict = {
  micro: {
    path: '/',
    element: <MicroRoute />,
    children: [],
  },
  workOrder: {
    path: '/flow',
    element: <WorkOrderLayout />,
    children: [
      {
        path: '/flow/empty',
        element: <WorkOrderEmptyPage />,
      },
    ],
  },
  mainRoute: {
    path: '/',
    element: <MainRoute />,
    children: [],
  },
}

const loginRoute = {
  path: 'login',
  element: process.env.APP_TYPE === 'platform' ? <LoginSimplify /> : <Login />,
  // loader: teamLoader,
}

const pagesRoute: any = {
  path: '/',
  element: <App />,
  // loader: rootLoader,
  errorElement: <ErrorPage />,
  children: [
    {
      path: '*',
      element: <Notfound />,
      // loader: teamLoader,
    },
  ],
}

const rootRoutes: Array<any> = [
  loginRoute,
  pagesRoute,
  {
    path: '/textMessageLink',
    element: <TextMessageLink />,
  },
]

export function combineRoutes(microApps, routes) {
  // const microRoutes: any[] = []
  const layoutRoutesMap = cloneDeep(layoutDict)

  microApps.map(appConfig => {
    const { path, layout, ...rest } = appConfig
    const route = {
      path: path || `/${rest.appName}/*`,
      element: createMicroApp({
        ...rest,
        baseroute: '/' + rest.appName,
        prodUrl: createProdUrl(rest.appName),
      }),
    }
    // 路由放在最外层，没有菜单
    if (layout === 'root') {
      rootRoutes.push(route)
    } else {
      layoutRoutesMap[layout || 'micro'].children.push(route)
    }
    // microRoutes.push(route)
  })

  // console.log('routeLayout', routeLayout)
  // const redirectPath = getLoginSuccessRoutePath(getUser())

  // if (redirectPath !== '/') {
  //   // 重定向到 个人工作台
  //   microRoutes.push({
  //     path: '/', // 数据视图
  //     element: <Navigate replace to={redirectPath}/>,
  //     // loader: teamLoader,
  //   })
  // }
  const layoutRoutes = Object.values(layoutRoutesMap)

  pagesRoute.children = [...layoutRoutes, ...routes, ...pagesRoute.children]

  return rootRoutes
}
